import Image from "next/image";
import Link from "next/link";
import React from "react";

const Logo = ({ home }) => (
  <Link href="/" title={home?.title} className="block shrink-0">
    <Image
      src="/logo.svg"
      alt="logo"
      width={218}
      height={42}
      className="w-40 h-11 xl:w-52 object-contain"
    />
  </Link>
);

export default Logo;
